import { BiDotsHorizontal } from "react-icons/bi";
import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Milestones",
  name: "milestones",
  type: "object",
  icon: BiDotsHorizontal,
  fields: [
    {
      name: "sectionLayoutConfig",
      type: "sectionLayoutConfig",
      title: "Section Layout",
      options: {
        collapsed: true,
        collapsable: true
      }
    },
    {
      name: "intro",
      title: "Intro content",
      type: "multilingualArrayText"
    },
    {
      name: "items",
      title: "Items",
      type: "array",
      of: [{ type: "milestoneItem" }]
    }
  ],
  preview: {
    select: {
      title: "heading.title",
      items: "items"
    },
    prepare({ title, items }) {
      return {
        title: multilingualStringPreview(title) || "(Milestones)",
        subtitle: `${(items || []).length} items`
      };
    }
  }
});
